import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { FileText } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { SHOP_DROPDOWN, CALENDAR_DROPDOWN } from '../components/navConfig';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const NAV_ITEMS = [
  { to: '/', label: 'Home' },
  { label: 'Shop', dropdown: SHOP_DROPDOWN('').filter((i) => i.to !== '/shop/wicks') },
  CALENDAR_DROPDOWN(''),
  { to: '/archive', label: 'Archive', active: true },
  { to: '/about', label: 'About' },
];

const FOOTER_LEGAL_LINKS = [
  { to: '/privacy', label: 'Privacy' },
  { to: '/terms', label: 'Terms' },
  { to: '/shipping', label: 'Shipping' },
  { to: '/faq', label: 'FAQ' },
];

function Archive() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/public/posts`);
        setPosts(response.data);
      } catch (error) {
        console.error('Error fetching posts:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchPosts();
  }, []);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="substack-site">
      {/* Header */}
      <Header navItems={NAV_ITEMS} />

      {/* Main Content */}
      <main className="archive-page">
        <div className="archive-container">
          <h1>Archive</h1>
          <p className="archive-subtitle">Browse all past newsletters and posts</p>

          {loading ? (
            <div className="archive-loading">
              <div className="loading-spinner"></div>
              <p>Loading posts...</p>
            </div>
          ) : posts.length === 0 ? (
            <div className="archive-empty">
              <FileText size={64} strokeWidth={1} />
              <h2>No posts yet</h2>
              <p>Check back soon! New stories and photos from the Outer Banks are coming.</p>
              <Link to="/subscribe" className="btn btn-primary">
                Follow to get notified
              </Link>
            </div>
          ) : (
            <div className="archive-list">
              {posts.map((post) => (
                <Link to={`/post/${post.slug}`} key={post.id} className="archive-item">
                  {post.featured_image && (
                    <div className="archive-item-image">
                      <img src={post.featured_image} alt={post.title} />
                    </div>
                  )}
                  <div className="archive-item-content">
                    <h2>{post.title}</h2>
                    {post.excerpt && <p className="archive-excerpt">{post.excerpt}</p>}
                    <span className="archive-date">{formatDate(post.created_at)}</span>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </main>

      {/* Footer */}
      <Footer showLogo={false} legalLinks={FOOTER_LEGAL_LINKS} />
    </div>
  );
}

export default Archive;
